import { jsx as _jsx } from "react/jsx-runtime";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackR2BReferralsClickOnPromoBannerClick } from "@faire/web-api--source/events/r2BReferrals/click/clickOnPromoBanner";
import userBrandReferrals from "@faire/web-api--source/routes/user/brand-referrals";
import React from "react";
export var ReferralFollowupBanner = function() {
    var bonusOffersReferralNamesList = getGlobalProperty("referralBonusOfferReferralNames");
    var _bonusOffersReferralNamesList_length;
    return /*#__PURE__*/ _jsx(Typography, {
        align: "center",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "f1fN02",
            defaultMessage: [
                {
                    type: 0,
                    value: "Limited-time offer: give "
                },
                {
                    type: 1,
                    value: "brandsWithBonusNumber"
                },
                {
                    type: 0,
                    value: " brands you invited one-on-one assistance from Faire. "
                },
                {
                    type: 8,
                    value: "LinkFormatting",
                    children: [
                        {
                            type: 0,
                            value: "Go to Referrals"
                        }
                    ]
                }
            ],
            values: {
                brandsWithBonusNumber: (_bonusOffersReferralNamesList_length = bonusOffersReferralNamesList === null || bonusOffersReferralNamesList === void 0 ? void 0 : bonusOffersReferralNamesList.length) !== null && _bonusOffersReferralNamesList_length !== void 0 ? _bonusOffersReferralNamesList_length : 0,
                LinkFormatting: function(chunks) {
                    return LinkFormatting(chunks);
                }
            }
        })
    });
};
var LinkFormatting = function(chunks) {
    return /*#__PURE__*/ _jsx(EmbeddedLink, {
        linkTo: userBrandReferrals(),
        onClick: trackR2BReferralsClickOnPromoBannerClick,
        color: "inherit",
        children: chunks
    });
};
